export const calcWorking = (data) => {
	const attendance = data.reduce(
		(prev, next) => prev + (next.attendance_at_work || 0),
		0,
	);
	return attendance;
};
